module.exports = __webpack_public_path__ + "media/tink.2a6bb6f5.wav";